import { render, staticRenderFns } from "./Flashcards.vue?vue&type=template&id=87ad71f6"
import script from "./Flashcards.vue?vue&type=script&lang=js"
export * from "./Flashcards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports